import styled from 'styled-components'
import { media } from '../../utilities/styled'

const SIZES = {
  desktop: 'DESKTOP',
  phone: 'PHONE',
}

function getHeightWidth(vertical, size) {
  /*
   * Vertical can be an array of booleans for phone and desktop,
   * an array with only one boolean for both phone and desktop,
   * or a boolean
   */

  let vert

  if (Array.isArray(vertical) && vertical.length === 2) {
    vert = size === SIZES.phone ? vertical[0] : vertical[1]
  } else {
    vert = Array.isArray(vertical) ? vertical[0] : vertical
  }

  return `
    height: ${vert ? '100%' : '2px'};
    width: ${vert ? '2px' : '100%'};
  `
}

export const StyledLine = styled.div`
  ${({ vertical }) => getHeightWidth(vertical, SIZES.desktop)};

  background-color: ${({ color, theme }) =>
    theme.colors[color] || theme.colors.grey2};
  flex-shrink: 0;

  ${media.phone`
    ${({ vertical }) => getHeightWidth(vertical, SIZES.phone)};
  `};
`
